
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { FooterBarLinkResource } from "app/models/FooterBarLinkResource";
import { FooterBarLinkListResource } from "app/models/FooterBarLinkListResource";
import { FooterConfigService } from "app/homepage-configuration/footer-config/footer-config.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NotificationsService } from "angular2-notifications";
import { FooterCellListResource } from "app/models/FooterCellListResource";

@Component({
  selector: 'vbn-footer-page-list',
  templateUrl: './footer-page-list.component.html',
  providers: [FooterConfigService],
  styleUrls: ['./footer-page-list.component.scss']
})
export class FooterPageListComponent implements OnInit {
  
  errorMessage: any;
  footerBarLinkListResource: FooterBarLinkListResource;
  footerBarLinkResource: FooterBarLinkResource;
  footerCellListResourceActive: FooterCellListResource;
  showShiftBtn: boolean = false;
  user = localStorage.getItem("_user");

  constructor(private footerConfigService: FooterConfigService, private router: Router, private translate: TranslateService, private _notificationService: NotificationsService) {
    this.footerBarLinkListResource = new FooterBarLinkListResource();
    this.footerBarLinkResource = new FooterBarLinkResource();
    this.footerCellListResourceActive = new FooterCellListResource();
   }

  ngOnInit() {
    this.getFooterPages();
    this.getAllFooterCellActive();
  }

  getAllFooterCellActive() {
    this.footerConfigService.getCellActive('/admin/footer/cell/getActive?email=' + this.user)
      .subscribe(
      body => {
        this.footerCellListResourceActive = body;
        if(this.footerCellListResourceActive != null){
          if(this.footerCellListResourceActive.footerCellListResource != null){
            let count = this.footerCellListResourceActive.footerCellListResource.length;
            if(count>=2){
              this.showShiftBtn = true;
            }
          }
        }
      },
      error => this.errorMessage = <any>error)
  }

  goToEditPages(rid: number) {
    this.router.navigate(['/footer-pages/' + btoa('{ "rid" : "' + rid + '"}')]);
  }

  deletePage(elem) {
    elem.showDeletePage = true;
  }

  getFooterPages() {
    this.footerConfigService.getFooterPagesService('/admin/footer/barLink/getAll?email=' + this.user)
      .subscribe(
        body => {
          this.footerBarLinkListResource = body;
        },
        error => this.errorMessage = <any>error)
  }

  deleteFooterPages(rid: number) {
    this.footerConfigService.deleteFooterPagesService('/admin/footer/barLink/delete/' + rid + "?email=" + this.user)
      .subscribe(
        response => {
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('The page has been successfully deleted!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.getFooterPages();
        },
        error => this.errorMessage = <any>error
      );
  }

}
